// Business constants - single source of truth. Replace values here to update across site.
export const BUSINESS = {
  nameFull: "مؤسسة ماجد صالح المخلفي لصيانة السيارات",
  nameBrand: "الكهربائي أسعد السوري",
  tagline: "متخصص تكييف وكهرباء السيارات",
  phone: "0502503032",
  phoneIntl: "+966502503032",
  whatsapp: "966502503032",
  address: "محمد بن إسماعيل الصنعاني، الخليج، الرياض",
  plusCode: "QQCX+9J الخليج، الرياض",
  city: "الرياض",
  district: "الخليج",
  country: "المملكة العربية السعودية",
  openingHours: "يفتح الساعة 8:30 صباحًا",
  openingHoursSchema: "Mo-Su 08:30-23:00",
  rating: 4.7,
  reviewsCount: 474,
  mapsUrl:
    "https://www.google.com/maps/place/%D9%83%D9%87%D8%B1%D8%A8%D8%A7%D8%A6%D9%8A+%D8%B3%D9%8A%D8%A7%D8%B1%D8%A7%D8%AA+%D8%AA%D9%83%D9%8A%D9%8A%D9%81+%D9%88%D8%AA%D8%A8%D8%B1%D9%8A%D8%AF+%D8%AA%D8%B1%D9%87%D9%8A%D9%85+%D9%85%D9%83%D9%8A%D9%81%D8%A7%D8%AA+%D8%AA%D8%B9%D8%A8%D8%A6%D8%A9+%D9%81%D8%B1%D9%8A%D9%88%D9%86+%D8%AA%D8%BA%D9%8A%D8%B1+%D8%AB%D9%84%D8%A7%D8%AC%D8%A9+%D9%85%D9%83%D9%8A%D9%81+%D8%AC%D9%85%D9%8A%D8%B9+%D8%A7%D9%84%D8%B3%D9%8A%D8%A7%D8%B1%D8%A7%D8%AA+-+%D8%A7%D9%84%D9%83%D9%87%D8%B1%D8%A8%D8%A7%D8%A6%D9%8A+%D8%A7%D8%B3%D8%B9%D8%AF+%D8%A7%D9%84%D8%B3%D9%88%D8%B1%D9%8A%E2%80%AD/@24.7709992,46.7990542,551m/data=!3m1!1e3",
  mapsEmbed:
    "https://www.google.com/maps?q=24.770901766741737,46.799059565324384&z=18&output=embed",
  coords: { lat: 24.770901766741737, lng: 46.799059565324384 },
  socials: {
    tiktok: "https://www.tiktok.com/@userk7t3dmlnkj",
    tiktokHandle: "@userk7t3dmlnkj",
    telegram: "https://t.me/asadsahab07",
    telegramHandle: "@asadsahab07",
  },
};

export const waLink = (message = "") => {
  const base = `https://wa.me/${BUSINESS.whatsapp}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};

export const telLink = `tel:${BUSINESS.phoneIntl}`;
